import React, { ReactElement, useState } from 'react';
import styles from './forgotPasswordPage.module.scss';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import CheckEmailConfirmation from './components/CheckEmailConfirmation';

const ForgotPasswordPage: React.FunctionComponent = (): ReactElement | null => {
    const [submittedUsername, setSubmittedUsername] = useState('');

    return (
        <>
            <div className={styles.gridContainer}>
                <div className={styles.page}>
                    <div className={styles.form}>
                        {submittedUsername ? (
                            <CheckEmailConfirmation backToPreviousScreen={(): void => setSubmittedUsername('')} />
                        ) : (
                            <ForgotPasswordForm setSubmittedUsername={setSubmittedUsername} />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ForgotPasswordPage;
